import { useState, useEffect } from "react";
import BackMethods from "../../back_component/BackMethods";
import { useNavigate, useLocation } from "react-router-dom";

export default function RolesManagementPage() {
    const location = useLocation();
    const successMessage = location.state?.successMessage;
    const [deleteSuccessMessage, setDeleteSuccessMessage] = useState("");
    const navigate = useNavigate();
    const { backEnd_request } = BackMethods();

    const [roles, setRoles] = useState([]);
    const [filteredRoles, setFilteredRoles] = useState([]);
    const [searchTerm, setSearchTerm] = useState("");
    const [filterType, setFilterType] = useState("all");
    const [isLoading, setIsLoading] = useState(true);

    const fetchRoles = async () => {
        setIsLoading(true);
        try {
            const res = await backEnd_request.get("/admin/Roles");
            const data = res.data.roles || res.data || [];
            setRoles(data);
            setFilteredRoles(data);
        } catch (error) {
            console.error(error);
        } finally {
            setIsLoading(false);
        }
    };

    useEffect(() => { fetchRoles(); }, []);

    const handleSearch = (term, type) => {
        setSearchTerm(term);
        setFilterType(type);
        let filtered = roles.filter((role) => {
            const searchVal = term.toLowerCase();
            if (type === "name") return role.name?.toLowerCase().includes(searchVal);
            if (type === "displayName") return role.displayName?.toLowerCase().includes(searchVal);
            return (
                role.name?.toLowerCase().includes(searchVal) ||
                role.displayName?.toLowerCase().includes(searchVal) ||
                role.description?.toLowerCase().includes(searchVal)
            );
        });
        setFilteredRoles(filtered);
    };

    const handleDelete = async (roleId) => {
        if (window.confirm("هل أنت متأكد من حذف هذا الدور؟")) {
            try {
                await backEnd_request.delete(`/admin/Roles/${roleId}`);
                fetchRoles();
                setDeleteSuccessMessage("تم حذف الدور بنجاح ✅");
                setTimeout(() => setDeleteSuccessMessage(""), 3000);
            } catch (error) { console.error(error); }
        }
    };

    const handleToggleActive = async (roleId, isActive) => {
        if (window.confirm(isActive ? "هل أنت متأكد من إلغاء تفعيل الدور؟" : "هل أنت متأكد من تفعيل الدور؟")) {
            try {
                await backEnd_request.patch("/admin/Roles/" + roleId + "/toggle-active", !isActive);
                fetchRoles();
            } catch (error) { console.error(error); }
        }
    };

    return (
        <div className="roles-container" style={{ direction: 'rtl', fontFamily: 'Cairo, sans-serif' }}>
            <div className="container py-5 px-3">

                {/* --- الهيدر --- */}
                <div className="d-flex flex-column flex-md-row justify-content-between align-items-center mb-5 gap-3">
                    <div>
                        <h2 className="fw-bold text-dark m-0">إدارة الأدوار</h2>
                        <p className="text-muted small mb-0">التحكم في المسميات والصلاحيات الوظيفية</p>
                    </div>
                    <button className="btn btn-dark rounded-3 px-4 py-2 fw-medium shadow-sm" onClick={() => navigate("/admin/roles-management/create")}>
                        <i className="bi bi-plus-lg ms-2"></i> إضافة دور جديد
                    </button>
                </div>

                {/* --- البحث --- */}
                <div className="bg-white border rounded-4 p-2 mb-4 shadow-sm">
                    <div className="row g-2">
                        <div className="col-md-9 border-end-md">
                            <div className="input-group">
                                <span className="input-group-text bg-transparent border-0 text-muted"><i className="bi bi-search"></i></span>
                                <input type="text" className="form-control border-0 shadow-none" placeholder="ابحث في الأدوار..." value={searchTerm} onChange={(e) => handleSearch(e.target.value, filterType)} />
                            </div>
                        </div>
                        <div className="col-md-3">
                            <select className="form-select border-0 shadow-none fw-medium" value={filterType} onChange={(e) => handleSearch(searchTerm, e.target.value)}>
                                <option value="all">بحث شامل</option>
                                <option value="name">الاسم التقني</option>
                                <option value="displayName">الاسم الظاهر</option>
                            </select>
                        </div>
                    </div>
                </div>

                {/* --- قائمة الكروت المحدثة --- */}
                {isLoading ? (
                    <div className="text-center py-5"><div className="spinner-border spinner-border-sm text-secondary"></div></div>
                ) : (
                    <div className="roles-list">
                        {filteredRoles.map((role) => (
                            <div key={role.roleId} className="role-card-premium bg-white border rounded-4 mb-3 transition-all">
                                <div className="p-4">
                                    <div className="row align-items-center g-4">

                                        {/* القسم الأول: الهوية والوصف */}
                                        <div className="col-lg-8">
                                            <div className="d-flex align-items-start gap-3">
                                                <div className={`icon-shape ${role.isSystemRole ? 'sys' : 'usr'}`}>
                                                    <i className={`bi ${role.isSystemRole ? 'bi-shield-lock' : 'bi-person-badge'}`}></i>
                                                </div>
                                                <div className="flex-grow-1">
                                                    <div className="d-flex align-items-center gap-2 mb-1">
                                                        <h5 className="fw-bold m-0 text-dark">{role.displayName}</h5>
                                                        {/* {role.isSystemRole && <span className="badge-sys">مستخدم نظام</span>} */}
                                                    </div>
                                                    {/* الوصف الآن يظهر بوضوح تحت المسمى */}
                                                    <p className="text-muted small mb-0 mt-2 role-desc">
                                                        {role.description || "لا يوجد وصف محدد لهذا الدور حالياً."}
                                                    </p>
                                                    <div className="mt-2 text-primary-emphasis fw-semibold" style={{ fontSize: '13px' }}>
                                                        {role.name}
                                                    </div>
                                                </div>
                                            </div>
                                        </div>

                                        {/* القسم الثاني: الحالة والإجراءات */}
                                        <div className="col-lg-4">
                                            <div className="d-flex flex-column flex-md-row align-items-center justify-content-lg-end gap-4">
                                                {/* عداد الصلاحيات والحالة */}
                                                <div className="d-flex gap-4 text-center">
                                                    <div>
                                                        <label className="d-block text-muted tiny-label">الصلاحيات</label>
                                                        <span className="fw-bold">{role.permissions?.length || 0}</span>
                                                    </div>
                                                    <div className="vr shadow-sm"></div>
                                                    <div>
                                                        <label className="d-block text-muted tiny-label">الحالة</label>
                                                        <span className={`fw-bold small ${role.isActive ? 'text-success' : 'text-danger'}`}>
                                                            {role.isActive ? 'نشط' : 'معطل'}
                                                        </span>
                                                    </div>
                                                </div>

                                                {/* الأزرار */}
                                                <div className="actions-group-minimal">
                                                    <button className="btn-circle-action" onClick={() => navigate(`/admin/roles-management/edit/${role.roleId}`)}><i className="bi bi-pencil"></i></button>
                                                    <button className={`btn-circle-action ${role.isActive ? 'active' : ''}`} onClick={() => handleToggleActive(role.roleId, role.isActive)}><i className={`bi ${role.isActive ? 'bi-lock' : 'bi-unlock'}`}></i></button>
                                                    {!role.isSystemRole && (
                                                        <button className="btn-circle-action text-danger" onClick={() => handleDelete(role.roleId)}><i className="bi bi-trash3"></i></button>
                                                    )}
                                                </div>
                                            </div>
                                        </div>

                                    </div>
                                </div>
                            </div>
                        ))}
                    </div>
                )}
            </div>

            <style>{`
                .role-card-premium { border-color: #eaecf0 !important; }
                .role-card-premium:hover { border-color: #0d6efd44 !important; box-shadow: 0 12px 20px rgba(0,0,0,0.02); }

                .icon-shape { width: 48px; height: 48px; border-radius: 12px; display: flex; align-items: center; justify-content: center; font-size: 1.4rem; }
                .icon-shape.sys { background: #fef3f2; color: #b42318; }
                .icon-shape.usr { background: #f0f9ff; color: #026aa2; }

                .badge-sys { background: #f9fafb; color: #475467; border: 1px solid #eaecf0; font-size: 10px; padding: 2px 8px; border-radius: 6px; font-weight: bold; }
                .role-desc { line-height: 1.6; max-width: 500px; display: block; }
                
                .tiny-label { font-size: 10px; font-weight: 700; color: #98a2b3; margin-bottom: 2px; }
                
                .actions-group-minimal { display: flex; gap: 8px; }
                .btn-circle-action { width: 38px; height: 38px; border-radius: 50%; border: 1px solid #eaecf0; background: white; color: #667085; transition: 0.2s; display: flex; align-items: center; justify-content: center; }
                .btn-circle-action:hover { background: #f9fafb; color: #0d6efd; border-color: #0d6efd; }
                .btn-circle-action.active { color: #f79009; }

                @media (max-width: 991px) {
                    .role-card-premium { text-align: center; }
                    .d-flex.align-items-start { flex-direction: column; align-items: center !important; }
                    .role-desc { max-width: 100%; }
                    .actions-group-minimal { width: 100%; justify-content: center; margin-top: 15px; }
                    .btn-circle-action { flex: 1; border-radius: 10px; }
                }
            `}</style>
        </div>
    );
}